"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitmovinAnalytics = void 0;
var tslib_1 = require("tslib");
var BitmovinAnalytics = /** @class */ (function () {
    function BitmovinAnalytics(analyticsConfig) {
        this.analyticsConfig = analyticsConfig;
    }
    BitmovinAnalytics.prototype.setup = function (videoAnalyticsConfig) {
        var _this = this;
        if (this.analyticsConfig.enable && typeof window !== 'undefined') {
            var initBitmovinAnalytics = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var Bitmovin8Adapter, error_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, Promise.resolve().then(function () { return tslib_1.__importStar(require('bitmovin-analytics')); })];
                        case 1:
                            Bitmovin8Adapter = (_a.sent()).Bitmovin8Adapter;
                            console.log('Bitmovin8Adapter loaded successfully.');
                            if (!videoAnalyticsConfig.playerInstance) {
                                console.error('Player instance is not defined.');
                                return [2 /*return*/];
                            }
                            new Bitmovin8Adapter(videoAnalyticsConfig.playerInstance);
                            console.log('Bitmovin8Adapter initialized successfully.');
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            console.error('Error initializing Bitmovin Analytics:', error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            initBitmovinAnalytics();
        }
        else {
            console.warn('Analytics are disabled or not in a browser environment.');
        }
    };
    return BitmovinAnalytics;
}());
exports.BitmovinAnalytics = BitmovinAnalytics;
